/* ANIME STYLE global behaviour: add to bag (AJAX), bag count, toast, manga SFX, hidden code, mobile menu. */
(function () {
  'use strict';
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  var SFX = ['ドン!', 'バン!', 'ゴゴゴ', 'ズン!'];
  var KONAMI = ['arrowup', 'arrowup', 'arrowdown', 'arrowdown', 'arrowleft', 'arrowright', 'arrowleft', 'arrowright', 'b', 'a'];
  var LOGO_TAPS = 5;
  var toastTimer;

  function toast(message) {
    var el = document.querySelector('.as-toast');
    if (!el) return;
    el.textContent = message;
    el.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-on'); }, 2400);
  }

  function sfx(x, y) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var s = document.createElement('span');
    s.className = 'as-sfx';
    s.setAttribute('aria-hidden', 'true');
    s.textContent = SFX[Math.floor(Math.random() * SFX.length)];
    s.style.left = x + 'px';
    s.style.top = y + 'px';
    document.body.appendChild(s);
    setTimeout(function () { s.remove(); }, 750);
  }

  function setCount(n) {
    document.querySelectorAll('[data-as-count]').forEach(function (el) {
      el.textContent = n;
      el.setAttribute('data-count', String(n));
    });
  }

  function refreshCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count); return cart; });
  }

  /* items: [{ id, quantity }] */
  function addToBag(items, point) {
    var strings = window.asStrings || {};
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (body) {
        if (!r.ok) throw new Error(body.description || body.message || strings.error || 'Error');
        return body;
      });
    }).then(function () {
      if (point) sfx(point.x, point.y);
      toast(strings.added || 'Added to bag');
      document.dispatchEvent(new CustomEvent('as:cart-updated'));
      return refreshCount();
    }).catch(function (err) {
      toast(err.message);
      throw err;
    });
  }

  /* White-background photos get the grey "packshot" tile automatically: we sample the image corners. */
  var BRIGHT = 200;
  function detectPackshot(img) {
    try {
      var c = document.createElement('canvas');
      c.width = 8; c.height = 8;
      var ctx = c.getContext('2d');
      ctx.drawImage(img, 0, 0, 8, 8);
      var d = ctx.getImageData(0, 0, 8, 8).data;
      var corners = [0, 7, 56, 63].map(function (p) { var i = p * 4; return (d[i] + d[i + 1] + d[i + 2]) / 3; });
      var avg = corners.reduce(function (a, b) { return a + b; }, 0) / corners.length;
      if (avg >= BRIGHT) img.closest('[data-as-stage]').classList.add('is-packshot');
    } catch (err) { /* canvas blocked: keep the dark stage */ }
  }
  function watchImages(scope) {
    (scope || document).querySelectorAll('img[data-as-detect]').forEach(function (img) {
      img.removeAttribute('data-as-detect');
      if (img.complete && img.naturalWidth) detectPackshot(img);
      else img.addEventListener('load', function () { detectPackshot(img); }, { once: true });
    });
  }
  watchImages();
  document.addEventListener('shopify:section:load', function (e) { watchImages(e.target); });

  window.asTheme = { toast: toast, sfx: sfx, addToBag: addToBag, refreshCount: refreshCount, watchImages: watchImages };

  /* Quick-add buttons on product cards: <button data-as-variant="123"> */
  document.addEventListener('click', function (e) {
    var quick = e.target.closest('[data-as-variant]');
    if (!quick) return;
    e.preventDefault();
    quick.disabled = true;
    addToBag([{ id: Number(quick.dataset.asVariant), quantity: 1 }], { x: e.clientX, y: e.clientY })
      .finally(function () { quick.disabled = false; });
  });

  /* Bundle buttons: <button data-as-bundle="111,222"> */
  document.addEventListener('click', function (e) {
    var bundle = e.target.closest('[data-as-bundle]');
    if (!bundle) return;
    e.preventDefault();
    var ids = bundle.dataset.asBundle.split(',').filter(Boolean).map(function (id) { return { id: Number(id), quantity: 1 }; });
    if (!ids.length) return;
    addToBag(ids, { x: e.clientX, y: e.clientY });
  });

  /* Mobile menu */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-as-menu-open]');
    var close = e.target.closest('[data-as-menu-close]');
    var drawer = document.querySelector('.as-drawer');
    if (!drawer) return;
    if (open) { drawer.classList.add('is-open'); drawer.removeAttribute('inert'); }
    if (close) { drawer.classList.remove('is-open'); drawer.setAttribute('inert', ''); }
  });

  /* Hidden code: Konami code or 5 taps on the logo (only when a code is set in the header section) */
  var awaken = document.querySelector('.as-awaken');
  function openAwaken() { if (!awaken) return; awaken.classList.add('is-on'); var b = awaken.querySelector('button'); if (b) b.focus(); }
  function closeAwaken() { if (awaken) awaken.classList.remove('is-on'); }
  if (awaken) {
    awaken.querySelector('button').addEventListener('click', closeAwaken);
    var step = 0;
    document.addEventListener('keydown', function (e) {
      var key = (e.key || '').toLowerCase();
      if (key === 'escape') { closeAwaken(); return; }
      step = key === KONAMI[step] ? step + 1 : (key === KONAMI[0] ? 1 : 0);
      if (step === KONAMI.length) { step = 0; openAwaken(); }
    });
    var logo = document.querySelector('[data-as-logo]');
    var taps = 0, tapTimer;
    if (logo) logo.addEventListener('click', function (e) {
      taps += 1;
      clearTimeout(tapTimer);
      tapTimer = setTimeout(function () { taps = 0; }, 1500);
      if (taps >= LOGO_TAPS) { e.preventDefault(); taps = 0; openAwaken(); }
      else if (taps > 1) { e.preventDefault(); }
    });
  }
})();
